import { Component, OnInit } from '@angular/core';
import { tabs } from '../../data/static/SelfEnrolTabs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-e-sign',
  templateUrl: './e-sign.component.html',
  styleUrls: ['./e-sign.component.css']
})
export class ESignComponent implements OnInit {
  tabs = [];
  agree = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.tabs = tabs;
  }

  agreeCheck() {
    if (!this.agree) {
      return true;
    }
    return false;
  }

  next() {
    this.router.navigate(['/selfEnroll/privacy']);
  }
}
